import axios from 'axios';
import { TokenService } from './TokenService';
import AuthApi from './auth/AuthApi';
import { authenticationStore } from '@/store/pinia/AuthenticationStore';
const baseURL = import.meta.env.VITE_API_REFRESH_URL as string;

const RefreshService = {
  getNewAccessToken: async () => {
    const refreshTokenValue = await TokenService.getRefreshToken();
    const accessTokenValue = await TokenService.getAccessToken();
    const axiosRefreshInstance = axios.create({
      baseURL: baseURL,
      headers: {
        Authorization: `Bearer ${refreshTokenValue}`
      }
    });
    const requestData = {
      access: accessTokenValue,
      refresh: refreshTokenValue
    };
    if (requestData.refresh !== '') {
      try {
        const response = await axiosRefreshInstance.post('', requestData);
        TokenService.saveAccessToken(response.data.access);
        TokenService.saveRefreshToken(response.data.refresh);
        const authStore = authenticationStore();
        await authStore.refreshLoginInformation();
        return response.data.access;
      } catch (error) {
        await AuthApi.cleanUpAndRedirectToLogin(true);
        throw error;
      }
    } else {
      await AuthApi.cleanUpAndRedirectToLogin();
    }
  }
};
export default RefreshService;
